import { FrameName } from "../config";
import GrasslandTerrainTileEntity from "./GrasslandTerrainTileEntity";

class Grassland4TerrainTileEntity extends GrasslandTerrainTileEntity {
	public static readonly frameName = FrameName.GRASSLAND4;
}

export default Grassland4TerrainTileEntity;
